export default __webpack_public_path__ + "c7849785038f64df2166244fc453648b.png";